import React from "react";
import ChooseUserPanelContent from "./routes/ChooseUserPanelContent";
import AuthPanel from "./routes/components/AuthPanel";
import { needHelp } from "./routes/components/links";
import { useLoaderData } from "react-router";

const ChooseUsersApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ChooseUserForExternalIdentityFrontModel>();

  const [errors, setErrors] = React.useState<string[]>([]);
  const [isSelectingUserId, setIsSelectingUserId] = React.useState<number>(undefined);

  const onUserSelected = async (user: server.dto.UserSmall) => {
    if (isSelectingUserId) return;

    setIsSelectingUserId(user.userId);
    try {
      const res = await window.CoreApi.ExternalIdentity.SignIn({ userId: user.userId });
      setErrors(res.data.errors.map(e => e.message));
      if (res.data.errors.length > 0) {
        setIsSelectingUserId(undefined);
      } else {
        window.location.href = viewModel.returnUrl;
      }
    } catch {
      setErrors([RESX.GeneralLabels.SomethingUnexpectedHappened]);
      setIsSelectingUserId(undefined);
    }
  };

  return <AuthPanel additionalFooterContent={needHelp}>
    <ChooseUserPanelContent
      errors={errors}
      users={viewModel.users}
      onUserSelect={onUserSelected}
      isLoadingUserId={isSelectingUserId}
    />
  </AuthPanel>;
};

export default ChooseUsersApp;